import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import firebase from 'firebase/app'
import 'firebase/auth'
import axios from 'axios'
import database from './database'

let app = ''
const config = {
    apiKey: process.env.APIKEY,
    authDomain: process.env.AUTHDOMAIN,
    databaseURL: process.env.DATABASEURL,
    projectId: process.env.PROJECTID,
    storageBucket: process.env.STORAGEBUCKET,
    messagingSenderId: process.env.MESSAGINGSENDERID,
    appId: process.env.APPID
}
firebase.initializeApp(config)

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(database)
firebase.auth().onAuthStateChanged((user) => {
    try {
        store.commit('setUser', user)
    } catch (error) { console.error(error) }
    if (!app) {
        app = new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount('#app')
    }
})
